export type ImageDto = {
  order: number;
  url: string;
  caption: string | null;
  altText: string;
  isDefault?: boolean;
  tags?: PhotoTag[];
};

export enum PhotoTag {
  Bathrooms = 'Bathrooms',
  BuildingAmenity = 'BuildingAmenity',
  BuildingConferenceCenter = 'BuildingConferenceCenter',
  BuildingExterior = 'BuildingExterior',
  BuildingFitnessCenter = 'BuildingFitnessCenter',
  BuildingLobby = 'BuildingLobby',
  BuildingLounge = 'BuildingLounge',
  Cafe = 'Cafe',
  CommonArea = 'CommonArea',
  FocusRoom = 'FocusRoom',
  HasPeople = 'HasPeople',
  HasPhoneBooths = 'HasPhoneBooths',
  HasSoftSeating = 'HasSoftSeating',
  HasWorkstation = 'HasWorkstation',
  LargeEventsSpace = 'LargeEventsSpace',
  Library = 'Library',
  MeetingRoom = 'MeetingRoom',
  MeetingRoomLarge = 'MeetingRoomLarge',
  OfficeUpTo15Seats = 'OfficeUpTo15Seats',
  OfficeLarge = 'OfficeLarge',
  PrivateOutdoorSpace = 'PrivateOutdoorSpace',
  Reception = 'Reception',
  WellnessRoom = 'WellnessRoom',
}
